import { BaseModel } from '..'

class Config extends BaseModel {
    constructor(json, ...args) {
        super(...args)
        this.apiRoot = 'frontend-api'
        this.apiVersion = 'public'
        this.apiBase = 'config'
    }

    fetch() {
        this._loading = true
        return new Promise((resolve, reject) => {
            try {
                window.debug.info(`Fetching config: ${this.base}`)
                this._client
                    .index(this.base)
                    .then((res) => {
                        return resolve({ config: res })
                    })
                    .catch((e) => {
                        return reject(e)
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }

    getSettings() {
        this._loading = true
        return new Promise((resolve, reject) => {
            try {
                window.debug.info(`Fetching settings: api/v1/settings`)
                this._client
                    .index('api/v1/settings')
                    .then((res) => {
                        return resolve({ settings: res })
                    })
                    .catch((e) => {
                        return reject(e)
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }
}

export { Config }
